// Every interaction point the tour can spotlight, in one registry.
// Components tag themselves with `data-tour={TOUR_ANCHOR.x}`; the overlay finds
// them by that attribute. Keeping the ids here means a renamed anchor is a
// compile error rather than a silently dead spotlight.

export const TOUR_ANCHOR = {
  // Sidebar (rendered by NavItem, keyed off the menu item id)
  NAV_DASHBOARD: 'nav-dashboard',
  NAV_ACCOUNTS: 'nav-account-configuration',
  NAV_COPIER: 'nav-copier-engine',
  NAV_COPIER_LOGS: 'nav-copier-logs',
  NAV_BILLING: 'nav-billing',
  NAV_INTEGRATIONS: 'nav-integration',

  // Billing / subscription
  BILLING_UPGRADE: 'billing-upgrade',
  CHECKOUT_PROCEED: 'checkout-proceed',
  // Sections of the checkout drawer's Configure step.
  CHECKOUT_CYCLE: 'checkout-cycle',
  CHECKOUT_TIERS: 'checkout-tiers',
  CHECKOUT_ADDONS: 'checkout-addons',
  CHECKOUT_TOTAL: 'checkout-total',
  // Payment step: the card picker (saved cards or the new-card form) and the pay key.
  CHECKOUT_CARD: 'checkout-card',
  CHECKOUT_PAY: 'checkout-pay',

  // The tour's plans ticket, row by row.
  TICKET_FROM: 'ticket-from',
  TICKET_TO: 'ticket-to',
  TICKET_TERMS: 'ticket-terms',
  TICKET_ACCOUNTS: 'ticket-accounts',
  TICKET_CONTINUE: 'ticket-continue',

  // Account configuration
  ACCOUNTS_ADD: 'accounts-add',
  ACCOUNT_PLATFORM_PICKER: 'account-platform-picker',
  ACCOUNT_SUBMIT: 'account-submit',

  // Copier engine
  COPIER_ADD: 'copier-add',
  COPIER_MASTER_SELECT: 'copier-master-select',
  COPIER_SLAVE_SELECT: 'copier-slave-select',
  COPIER_RISK_TYPE: 'copier-risk-type',
  // Sections of the Add Copier drawer, walked one at a time.
  COPIER_RISK_SECTION: 'copier-risk-section',
  COPIER_SLTP_SECTION: 'copier-sltp-section',
  COPIER_ADVANCED_SECTION: 'copier-advanced-section',
  COPIER_FILTERS_SECTION: 'copier-filters-section',
  // Every slave row carries this; querySelector takes the first, which is what
  // the walkthrough wants.
  COPIER_SLAVE_EDIT: 'copier-slave-edit',
  COPIER_SAVE: 'copier-save',

  // Protection. Reached via the accounts table row settings icon, then the
  // Equity Protector tab inside account settings.
  ACCOUNT_ROW_SETTINGS: 'account-row-settings',
  EQUITY_PROTECTOR_TAB: 'equity-protector-tab'
} as const;

export type TourAnchor = (typeof TOUR_ANCHOR)[keyof typeof TOUR_ANCHOR];

export const anchorSelector = (a: TourAnchor) => `[data-tour="${a}"]`;

// Menu item id (menu-items.tsx) -> anchor, so NavItem can tag itself without
// each item needing to know about the tour.
export const NAV_ANCHOR_BY_MENU_ID: Record<string, TourAnchor> = {
  dashboard: TOUR_ANCHOR.NAV_DASHBOARD,
  'account-configuration': TOUR_ANCHOR.NAV_ACCOUNTS,
  'copier-engine': TOUR_ANCHOR.NAV_COPIER,
  'copier-logs': TOUR_ANCHOR.NAV_COPIER_LOGS,
  billing: TOUR_ANCHOR.NAV_BILLING,
  integration: TOUR_ANCHOR.NAV_INTEGRATIONS
};
